import React,{useState} from 'react';
import { Segment, Label } from 'semantic-ui-react';



const Product1 = () =>{
    

    const information = {intro: "When you walk into a public bathroom the anxiety of not having the hygiene level you enjoy at your home is very common. Even when the bathroom seems clean and pristine you never know who the last person was and whether that person was hosting some germs that he doesn’t even know.",
                        satisfaction: "With Touchless Hygiene Systems, we guarantee that your facility’s restrooms will be comforting for the rightfully worried customers and cleaner than ever.",
                        description: "Touchless Hygiene System seats come with a housing system in which a hygienic roll of toilet cover is stored. Every time a customer wants to use the restroom, a new clean and hygienic seat cover is released from the rights side of the housing system and goes through the seat, covering it while the previously used hygienic seat will be rolled into the left side of the housing system.",
                        functionality: "The plastic cover starts to roll out a fresh seat with the help of a wall mounted touchless system that comes with our seat. Once you wave your hand in front of the sensory system the machinestarts to work and in seconds you have your unused, fresh, hygienic seat.",
                        capacity: "Our rolls have 80 toilet seats in them and once the roll is over the machine alerts you to replace the roll which is easy and practical."}

    const [mainDisplay, setMainDisplay] = useState(information.intro);

    const handleClick = (e) => {
        document.getElementById("intro").classList.remove("active");
        document.getElementById("satisfaction").classList.remove("active");
        document.getElementById("description").classList.remove("active");
        document.getElementById("functionality").classList.remove("active");
        document.getElementById("capacity").classList.remove("active");
        document.getElementById(`${e.target.id}`).classList.add("active");

        switch(e.target.id){
            case 'intro':
                setMainDisplay(information.intro);
                break;

            case 'satisfaction':
                setMainDisplay(information.satisfaction);
                break;

            case 'description':
                setMainDisplay(information.description);
                break;

            case 'functionality':
                setMainDisplay(information.functionality);
                break;

            case 'capacity':
                setMainDisplay(information.capacity);
                break;
            default:
                setMainDisplay(information.intro);


        }

    }
    return (
           
            <div id="product-container" className="ui grid">
                <div className="three wide column">
                    <div className="ui vertical fluid tabular menu">
                        <a id="intro" className="item active standard-text" onClick={handleClick}>Introduction</a>
                        <a id="satisfaction" className="item standard-text" onClick={handleClick}>Satisfaction</a>
                        <a id="description" className="item standard-text" onClick={handleClick}>Description</a>
                        <a id="functionality" className="item standard-text" onClick={handleClick}>Functionality</a>
                        <a id="capacity" className="item standard-text" onClick={handleClick}>Capacity</a>
                    </div>
                </div>
                <div className="twelve wide stretched column">
                    <div className="ui segment">
                    <Segment className="product-segment" color="teal" ><p className="main-display-text">{mainDisplay}</p></Segment>
                    </div>
                </div>
            </div>
            
        )
}

export default Product1;